import PropTypes from 'prop-types';

import React, { Component } from 'react';

import ReactMediaPlayer from '../../../../../../components/ReactMediaPlayer/ReactMediaPlayer';

export default class AudioCardDark extends Component {
  static propTypes = {
    cardId: PropTypes.string.isRequired,
    card: PropTypes.object.isRequired
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.cardId !== nextProps.cardId) {
    }
  }

  render() {
    // console.log(this.props);
    return (
      <div
        style={styles.container}
        className="audioPlayerContainer"
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <ReactMediaPlayer
          src={this.props.card.url}
          style={{ width: '100%' }}
          autoPlay={!this.props.isPreview}
        />
      </div>
    );
  }
}

const styles = {
  container: {
    display: 'flex',
    width: '100%',
    height: '200px',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '30px 0px 20px'
  },
  image: {
    maxWidth: '460px',
    margin: '0 auto',
    display: 'block',
    height: 'auto'
  }
};
